import { IAccountChecklistTemplatesGetParams } from 'CorePackage/AccountModule/actions/accountActions';

import { USER_CHECKLIST_PAGE_SIZE } from './userChecklistPageSize';

export const initialCheckListTemplatesParams: IAccountChecklistTemplatesGetParams = {
  isCaching: false,
  order: '',
  page: '0',
  size: USER_CHECKLIST_PAGE_SIZE,
};
